import { Dropdown as AntDropdown } from 'antd';
import { DropdownButtonProps } from 'antd/lib/dropdown';
import React from 'react';
import { AngleDownIcon } from '@revfluence/fresh-icons/solid';
import cx from 'classnames';

import styles from './Dropdown.module.scss';

const { Button: AntDropdownButton } = AntDropdown;

export interface IDropdownButtonProps extends DropdownButtonProps {}

/**
 * Dropdown component
 */
export const Button: React.FC<DropdownButtonProps> = ({
  className,
  ...restProps
}) => {
  const { icon = <AngleDownIcon /> } = restProps;
  return (
    <AntDropdownButton
      icon={icon}
      className={cx(styles.DropdownButton, className)}
      {...restProps}
    />
  );
};
